import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgId = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-id",
	viewBox: "0 0 640 480",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#e70011",
		d: "M0 0h640v240H0Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M0 240h640v240H0Z"
	})]
});
export default SvgId;
